"use client";

import { X } from "lucide-react";
import { TextDisplay } from "lumir-back-office-ui/RmsTextDisplay";

const Terms = ({ handleTermsClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="relative w-full max-w-[800px] rounded-lg bg-white p-[24px] shadow-lg overflow-y-auto max-h-[90vh]">
        <div className="flex items-center justify-between pb-[24px]">
          <TextDisplay
            size="lg"
            textData={{
              primary: "개인정보 수집·이용·제공 동의서",
            }}
          />
          <button
            onClick={handleTermsClose}
            className="rounded-full p-1 hover:bg-gray-100"
          >
            <X className="h-10 w-10" />
          </button>
        </div>

        <div className="mt-4 text-sm space-y-[24px]">
          <TextDisplay
            size="md"
            textData={{
              description: `루미르 주식회사(이하 "회사")는 채용절차와 관련하여 다음과 같이 입사지원자의 개인정보를 수집, 이용하는데 동의를 받고자 합니다.귀하는 동의를 거부할 권리가 있으며, 입사 및 근로계약 등에 필요한 최소한의 개인정보 수집이 불가능할 경우에는 정상적인 채용절차가 진행되지 않음을 알려 드립니다.`,
            }}
          />

          <div>
            <h3 className="typography-semantic-body-2-normal---bold pb-[8px]">
              1. 개인정보 수집 및 이용 목적{" "}
              <span className="text-semantic-error-global-global-default">
                *
              </span>
            </h3>
            <TextDisplay
              className="pb-[24px]"
              size="lg"
              textData={{
                description:
                  "회사는 다음과 같은 목적을 위해 입사지원자의 개인정보를 수집하고 있습니다.",
              }}
            />

            <div className="overflow-x-auto">
              <table className="w-full rounded-lg overflow-hidden">
                <thead>
                  <tr className="bg-gray-50 typography-semantic-body-2-normal---bold border-b border-gray-300">
                    <th className="px-[16px] py-[8px] text-left w-5/12">
                      수집 항목
                    </th>
                    <th className="px-[16px] text-left w-5/12">
                      수집 이용 목적
                    </th>
                    <th className="px-[16px] text-left">보유 기간</th>
                  </tr>
                </thead>
                <tbody className="typography-semantic-body-2-normal---regular">
                  <tr className="border-b border-gray-300">
                    <td className="p-[16px]">사진, 성명, 생년월일</td>
                    <td className="px-[16px] border-r border-gray-300">
                      본인 확인 및 식별, 입사지원 서비스 제공
                    </td>
                    <td className="p-2 text-center" rowSpan={5}>
                      1년
                    </td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="p-[16px]">연락처(휴,집전), 이메일, 주소</td>
                    <td className="px-[16px] border-r border-gray-300">
                      채용관련 고지사항 전달 및 결과 안내
                    </td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="p-[16px]">
                      학력사항, 원입직무, 자기소개서, 업무관련 자격사항,
                      경력사항(근무기간, 근무처, 직위, 담당업무, 장애여부 확인,
                      병역해당 확인)
                    </td>
                    <td className="px-[16px] border-r border-gray-300">
                      채용 적합성 판단 및 서류심사, 면접 등의 근거자료로 활용
                    </td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="p-[16px]">
                      외국어능력, PC활용, 업무의 자격사항, 가족사항, 병역사항
                    </td>
                    <td className="px-[16px] border-r border-gray-300">
                      채용 적합성 판단 및 서류 심사/면접 등의 근거자료로 활용
                    </td>
                  </tr>
                  <tr className="">
                    <td className="p-[16px]">건강정보</td>
                    <td className="px-[16px] border-r border-gray-300">
                      채용 적합성 판단 근거 자료로 활용
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <TextDisplay
              size="md"
              textData={{
                description:
                  "※ 필수 사항 수집에 동의하지 않으시면 입사지원을 하실 수 없습니다.",
              }}
            />
          </div>

          <div className="mb-6">
            <h3 className="typography-semantic-body-2-normal---bold pb-[8px]">
              2. 개인정보 보유 및 이용 기간{" "}
              <span className="text-semantic-error-global-global-default">
                *
              </span>
            </h3>
            <TextDisplay
              size="lg"
              textData={{
                description:
                  "회사는 입사지원자가 지원자 본인의 개인정보의 삭제를 요청 시 즉각 삭제 처리합니다. 단, 별도의 삭제 요청이 없을 경우, 입사지원 이력관리를 위해 1년간 보관됩니다.",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export { Terms };
